import React from "react";
import { MDBCol } from "mdbreact";

//Components
import Navbar from "../../components/Navbar_inicio";
import FooterPage from "../../components/Footer";

//CSS
import "./Inicio.css";

//Landing sections
import Start from "./sections/Start";
import HowUse from "./sections/HowUse";
import Envio from "./sections/Envio";
import Seguridad from "./sections/Seguridad";
import Recomendaciones from "./sections/Recomendaciones";

class InicioPassengers extends React.Component {
  render() {
    return (
      <div id="appp">
        <MDBCol style={{ padding: "0px" }}>
          <Navbar />
          <Start />
          <HowUse />
          <Envio />
          <Seguridad />
          <Recomendaciones />
          <FooterPage />
        </MDBCol>
      </div>
    );
  }
}

export default InicioPassengers;
